import { createSlice } from "@reduxjs/toolkit";

const customerCouponSlice = createSlice({
  name: "customerCoupon",
  initialState: {
    templates: [],
    templateTotal: 0,
    templatesLoading: false,
    creating: false,
    createSuccess: false,
    coupons: [],
    couponTotal: 0,
    couponsLoading: false,
    couponTransactions: [],
    couponTransactionTotal: 0,
    couponTransactionsLoading: false,
    couponTransactionMeta: null,
    error: null,
  },
  reducers: {
    fetchTemplatesRequest: (state) => {
      state.templatesLoading = true;
      state.error = null;
    },
    fetchTemplatesSuccess: (state, action) => {
      state.templatesLoading = false;
      state.templates = action.payload.data || [];
      state.templateTotal = action.payload.total || 0;
    },
    fetchTemplatesFailure: (state, action) => {
      state.templatesLoading = false;
      state.error = action.payload;
    },

    createTemplateRequest: (state) => {
      state.creating = true;
      state.createSuccess = false;
      state.error = null;
    },
    createTemplateSuccess: (state) => {
      state.creating = false;
      state.createSuccess = true;
    },
    createTemplateFailure: (state, action) => {
      state.creating = false;
      state.createSuccess = false;
      state.error = action.payload;
    },
    resetCreateState: (state) => {
      state.createSuccess = false;
    },

    updateTemplateStatusRequest: (state) => {
      state.error = null;
    },
    updateTemplateStatusSuccess: (state) => {},
    updateTemplateStatusFailure: (state, action) => {
      state.error = action.payload;
    },

    deleteTemplateRequest: (state) => {
      state.error = null;
    },
    deleteTemplateSuccess: (state) => {},
    deleteTemplateFailure: (state, action) => {
      state.error = action.payload;
    },

    fetchCouponsRequest: (state) => {
      state.couponsLoading = true;
      state.error = null;
    },
    fetchCouponsSuccess: (state, action) => {
      state.couponsLoading = false;
      state.coupons = action.payload.data || [];
      state.couponTotal = action.payload.total || 0;
    },
    fetchCouponsFailure: (state, action) => {
      state.couponsLoading = false;
      state.error = action.payload;
    },

    fetchCouponTransactionsRequest: (state) => {
      state.couponTransactionsLoading = true;
      state.error = null;
    },
    fetchCouponTransactionsSuccess: (state, action) => {
      state.couponTransactionsLoading = false;
      state.couponTransactions = action.payload.data || [];
      state.couponTransactionTotal = action.payload.total || 0;
      state.couponTransactionMeta = action.payload.coupon || null;
    },
    fetchCouponTransactionsFailure: (state, action) => {
      state.couponTransactionsLoading = false;
      state.error = action.payload;
    },
    clearCouponTransactions: (state) => {
      state.couponTransactions = [];
      state.couponTransactionTotal = 0;
      state.couponTransactionsLoading = false;
      state.couponTransactionMeta = null;
    },
  },
});

export const {
  fetchTemplatesRequest,
  fetchTemplatesSuccess,
  fetchTemplatesFailure,
  createTemplateRequest,
  createTemplateSuccess,
  createTemplateFailure,
  resetCreateState,
  updateTemplateStatusRequest,
  updateTemplateStatusSuccess,
  updateTemplateStatusFailure,
  deleteTemplateRequest,
  deleteTemplateSuccess,
  deleteTemplateFailure,
  fetchCouponsRequest,
  fetchCouponsSuccess,
  fetchCouponsFailure,
  fetchCouponTransactionsRequest,
  fetchCouponTransactionsSuccess,
  fetchCouponTransactionsFailure,
  clearCouponTransactions,
} = customerCouponSlice.actions;

export default customerCouponSlice.reducer;
